import React from "react";
import { useTranslation } from "react-i18next";

import { useOrderManager } from "~/managers/use-order-manager";
import { RegisterButton } from "../ui/register-button";

export default function OrderActionContext({
  onClose,
}: {
  onClose: () => void;
}) {
  const { updateOrder } = useOrderManager();

  const { t } = useTranslation("common");

  const handleOrderWithoutPrinting = async () => {
    await updateOrder({
      printTicket: false,
      printAll: false,
      closeAfterUpdate: true,
    });
    onClose();
  };

  const handleOrderWithPrintAll = async () => {
    await updateOrder({
      printTicket: true,
      printAll: true,
      closeAfterUpdate: true,
    });
    onClose();
  };
  return (
    <div className="flex flex-col gap-2">
      <RegisterButton
        variant="destructive"
        onClick={handleOrderWithoutPrinting}
      >
        {t("Cart.order_without_printing")}
      </RegisterButton>
      <RegisterButton variant="secondary" onClick={handleOrderWithPrintAll}>
        {t("Cart.order_print_all")}
      </RegisterButton>
    </div>
  );
}
